import { create } from 'zustand'

interface BulkMutationProgressState {
  active: boolean
  setActive: (active: boolean) => void
  total: number
  setTotal: (total: number) => void
  progress: number
  updateProgress: () => void
  timeRemainingInSeconds: number | null

  mutationStartTime: Date | null
  mutationEndTime: Date | null
  resetValues: () => void
  setUpdateMessage: (updateMessage: {
    updatedMessage?: string
    updatingMessage: string
  }) => void
  updateMessage: { updatedMessage?: string; updatingMessage: string }
}

const useBulkMutationProgressStore = create<BulkMutationProgressState>(
  (set, get) => ({
    active: false,
    setActive: (active: boolean) => {
      if (!active) {
        set({ progress: 0 })
      }
      if (active) {
        set({ mutationStartTime: new Date() })
      }

      set({ active })
    },
    total: 0,
    setTotal: (total: number) => set({ total }),
    progress: 0,
    setUpdateMessage: updateMessage => {
      set({ updateMessage: updateMessage })
    },
    timeRemainingInSeconds: null,

    mutationStartTime: null,
    mutationEndTime: null,
    resetValues: () => {
      set({
        active: false,
        total: 0,
        progress: 0,
        timeRemainingInSeconds: null,
        mutationStartTime: null,
        mutationEndTime: null,
      })
    },
    averageMutationTime: null,
    updateMessage: { updatedMessage: undefined, updatingMessage: '' },
    updateProgress: () => {
      const state = get()
      const mutationStartTime = state.mutationStartTime
      if (state.progress >= state.total) {
        return
      }
      if (mutationStartTime) {
        const currentStep =
          state.progress === state.total ? state.progress : state.progress + 1
        const endTime = new Date()
        const averageMutationTime =
          (endTime.getTime() - mutationStartTime.getTime()) / currentStep

        const timeRemaining = averageMutationTime * (state.total - currentStep)
        const timeRemainingInSeconds = Math.floor(timeRemaining / 1000)

        return set(state => {
          return {
            ...state,
            progress: state.progress + 1,
            timeRemainingInSeconds,
          }
        })
      }
      return set(state => {
        return {
          ...state,
          progress: state.progress + 1,
        }
      })
    },
  }),
)

export default useBulkMutationProgressStore
